import React from "react";
import { adminApi as api } from "../../../../util/api";
import { ImportModal } from "../../../components/ImportModal";

export const ImportAvailityErrorRulesModal = ({ onImport, ...rest }) => {
  const handleImport = async (values) => {
    const response = await api.post("/admin/availity_error_rules/import.json", {
      file: { bytes: values.file },
    });

    onImport?.(response.data?.meta?.message, response.data?.meta?.error_details);
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Import Availity Error Rules..."
      exampleDownloadPath="/admin/availity_error_rules/example"
    />
  );
};
